import './third-step.scss';

import { useContext } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

import { FileUpload, PhotoUpload } from '@/components/Shared/ui';
import type { FileType } from '@/types/uploadFiles';

import { CreateTabContext } from '../../../ExistedOrder';
import { Documents } from '../../entities';
import type { CreateAutoCreditProps } from '../../types/form-types';

const ThirdStep: React.FC = () => {
  const { isFieldsFrozen } = useContext(CreateTabContext);
  const { control } = useFormContext<CreateAutoCreditProps>();

  const socialStatus = useWatch({ control, name: 'socialStatus' });

  return (
    <div className="third-step">
      {socialStatus === '3' ? ( // Военнослужащий
        <div>
          <h2 className="order-step__main-title">
            Идентификационная информация
          </h2>

          <div className="third-step__margin-top">
            <Controller
              control={control}
              name="docScanSocialStatus"
              rules={{
                required: 'Выберите файл',
                validate: (value) => {
                  if (!value || !value.name) return 'Выберите файл';
                  if ('size' in value && (value?.size || 0) > 10_000_000)
                    return 'Файл не должен превышать 10 МБ';
                }
              }}
              render={({ field, fieldState: { error } }) => (
                <FileUpload
                  title="Скан документа, подтверждающий социальный статус"
                  file={field.value as FileType}
                  onChange={field.onChange}
                  onDelete={() => field.onChange(null)}
                  helperText="Максимальный размер файла 10 МБ"
                  error={error?.message}
                  isRequired
                  accept=".pdf"
                  allowedExtensions={['pdf']}
                />
              )}
            />
          </div>
        </div>
      ) : null}

      <p className="order-step__main-title">Фотография и документы</p>

      <div className="third-step__margin-top third-step__container">
        <Controller
          control={control}
          name="clientPhoto"
          rules={{
            required: 'Выберите файл',
            validate: (value) => {
              if (!value || !value.name) return 'Выберите файл';
              if ('size' in value && (value?.size || 0) > 10_000_000)
                return 'Файл не должен превышать 10 МБ';
            }
          }}
          render={({ field, fieldState: { error } }) => (
            <PhotoUpload
              title="Фотография клиента"
              file={field.value as FileType}
              onChange={field.onChange}
              onDelete={() => field.onChange(null)}
              error={error?.message}
              isFrozen={isFieldsFrozen}
              isRequired
            />
          )}
        />

        <div className="third-step__documents">
          <Documents />
        </div>
      </div>
    </div>
  );
};

export default ThirdStep;
